import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAppNetworkSettingsKey } from '../../utils/keys';
export const useUpdateAppNetworkSettings = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.app.updateNetworkSettings(input), {
        onMutate: variables => {
            const appInstallationsKey = getAppNetworkSettingsKey({
                appId: variables.appId,
            });
            queryClient.setQueriesData(appInstallationsKey, () => variables.settings);
        },
        onSettled: () => {
            const appInstallationsKey = getAppNetworkSettingsKey();
            queryClient.invalidateQueries(appInstallationsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUpdateAppNetworkSettings.js.map